import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SortableElement } from 'react-sortable-hoc';
import Immutable, { is } from 'immutable';
import PropTypes from 'prop-types';
import i18n from 'react-intl-universal';
import classNames from 'classnames';
import { getState as globalState } from '@/reducers/Global/GlobalReducer';
import { setSortedNoteData } from '@/actions/GlobalAction';

import styles from './NotebookItem.scss';
import { deleteNotebookSoft, renameNotebook } from '../../../actions/NotebooksAction';
import Message from '../../../components/Message';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { MenuItem } from '../../../components/Menu/';
import Modal from '../../../components/Modal';
import { martinDispatch } from '../../../utils/util';
import { getNormalPageUrl } from '../../../utils/urlHelper';

@connect(
  state => ({
    globalState: globalState(state),
    // noteBooks: getState(state),
    // locale: getGlobalState(state).get('locale'),
  }),
  dispatch => ({
    setSortedNoteData: data => dispatch(setSortedNoteData(data)),
    deleteNotebookSoft: id => martinDispatch(dispatch, deleteNotebookSoft(id)),
    renameNotebook: (nbId, name) => dispatch(renameNotebook(nbId, name)),
  }),
)

@SortableElement
@withRouter
export default class NotebookItem extends Component {
  static propTypes = {
    notebook: PropTypes.object,
    active: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      dragOnItem: false, // 意图移动文章到这里，需要一个active样式
      menuItems: [
        {
          icon: 'pencil-square-o',
          text: '修改文集',
          action: 'md-nbook',
        },
        {
          icon: 'trash-o',
          text: '删除文集',
          action: 'del-nbook',
        },
      ],
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    // eslint-disable-next-line max-len
    return !is(this.state, nextState) || !(is(this.props.notebook, nextProps.notebook) && this.props.active === nextProps.active);
  }
  setIsCursorOnNbItem = (isOn) => {
    const { notebook, history, match } = this.props;
    const newNbId = notebook.get('id');
    const sortingNote = this.props.globalState.get('sortingNote').toJS();
    this.setState({
      dragOnItem: sortingNote.isSorting && isOn,
    });
    // must set false when onMouseLeaveItem
    if (sortingNote.isSorting || !isOn) {
      this.props.setSortedNoteData(Object.assign(sortingNote, {
        isCursorOnNbItem: isOn,
        newNbId: isOn ? newNbId : null,
      }));
    }
  }
  // 鼠标移动到item上面
  onMouseEnterItem = () => {
    this.setIsCursorOnNbItem(true);
  }
  onMouseLeaveItem = () => {
    this.setIsCursorOnNbItem(false);
  };
  navNotebook = () => {
    const { notebook, history, match } = this.props;
    const nbId = notebook.get('id');
    if (+nbId !== +match.params.nbId) {
      const notes = notebook.get('notes', Immutable.fromJS([]));
      if (notes.size > 0) {
        history.push(`/notebooks/${nbId}/notes/${notes.first()}`);
      } else {
        history.push(`/notebooks/${nbId}`);
      }
    }
  };

  // 跳转到下一篇或者上一篇
  autoGotoNextNotebook = () => {
    const { preNbId, nextNbId, history } = this.props;
    const { match: { params: { nbId } } } = this.props;
    // 避免push相同的path
    if (+nbId !== +preNbId) {
      history.replace(getNormalPageUrl(nextNbId || preNbId));
    } else {
      history.replace('/');
    }
  };

  delNoteBook = (nbId) => {
    const { notebook } = this.props;
    Modal.Confirm(i18n.get('notebooks.del-notebook-tip', { name: notebook.get('name') }), {
      onOk: () => {
        this.props.deleteNotebookSoft(nbId).then((res) => {
          this.autoGotoNextNotebook();
        }).catch((error) => {
          Message.error(i18n.get('error.fail-refresh'));
        });
      },
      onCancel: () => {
      },
    });
  }

  // 修改文集名称
  renameNoteBook = (nbId) => {
    const { notebook } = this.props;
    Modal.Prompt(i18n.get('notebooks.rename-notebook-tip'), notebook.get('name'), {
      onOk: (newName, oldName) => {
        if (newName) {
          this.props.renameNotebook(nbId, newName);
        }
      },
      onCancel: () => {
      },
    });
  }

  onDropdownItemClick = (e, data = {}) => {
    const { notebook } = this.props;
    const nbId = notebook.get('id');
    switch (data.index) {
      case 'del-nbook':
        this.delNoteBook(nbId);
        break;
      case 'md-nbook':
        this.renameNoteBook(nbId);
        break;
      default:
        break;
    }
    document.body.click(); // close the dropdown
  };

  renderDropDownMenu = () => {
    const { menuItems } = this.state;
    return menuItems.map((v, k) => {
      return <MenuItem key={k} index={v.action} iconName={v.icon}>{v.text}</MenuItem>;
    });
  }

  render() {
    const { menuItems, dragOnItem } = this.state;
    const { notebook, active } = this.props;
    const name = notebook.get('name');
    const nbId = notebook.get('id');
    // console.log(`${notebook.get('id')} : ${name}`);
    const itemClass = classNames({
      [`${styles['notebook-item']}`]: true,
      [`${styles['notebook-item-active']}`]: active,
      [styles['notebook-item-drag-on']]: dragOnItem,
    });
    return (
      <li
        className={itemClass}
        title={name}
        onClick={this.navNotebook}
        onMouseEnter={this.onMouseEnterItem}
        onMouseLeave={this.onMouseLeaveItem}
      >
        {active &&
        <Dropdown
          className={styles['dropdown']}
          menuItems={this.renderDropDownMenu()}
          onItemClick={this.onDropdownItemClick}
          sortable
        />}
        <span>{name}</span>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotebookList/NotebookItem/NotebookItem.js